import { ActionBase } from '../../../core/store/action/ActionBase';
import { RuleModel } from "../../models/RuleModel";

export const GET_RELATED_DATASETS = '[Rule] Get Related DataSets';

export class GetDataSetsAction implements ActionBase {
  readonly identifier = new Date().getTime().toString();
  readonly type = GET_RELATED_DATASETS;

  constructor( public payload: { model: RuleModel }) {

  }
}



// WEBPACK FOOTER //
// ./src/app/businessRule/store/actions/GetDataSetsAction.ts